import React,{useEffect, useState}  from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import {HiOutlineLocationMarker} from 'react-icons/hi'

const cityDetail= [
    {
        City:"Delhi",
        station:"NDLS New Delhi Railway Station"
    },
    {   City:"Mumbai",
        station:"MMCT Mumbai Railway Station"
    },
    {   City:"Goa",
        station:"PJP Panaji Railway Station"
    },
    {   City:"Kolkata",
        station:"KOAA Kolkata Junction"
    },
    {   City:"Banglore",
        station:"SBC Bengaluru City Railway Station"
    },
    {   City:"Chennai",
        station:"MAS Chennai Central Railway Station"
    },
]

export default function TrainMenu(props) {
  const [selectCity, setSelectCity] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleCity = (e)=>{
    setSelectCity(e.target.id);
  }
  useEffect(()=>{
    if(!selectCity){
      return;
    }
    const tempArrObj = cityDetail.filter(elem=>elem.City===selectCity);
    props.setterFunc(tempArrObj[0]);
    props.removeMenu(false);
    setAnchorEl(null);
  }, [selectCity])

  return (
    <div>
      <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        sx={{color: 'red', fontSize:'40px', width:'80vw', height:'150px', backgroundColor:'transparent'}}
      >
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {cityDetail.map(el=>{
            return <MenuItem onClick={handleCity} sx={{width:'80vw', display:'flex', flexDirection:'column', alignItems:'baseline', backgroundColor:'#f3f3f3', marginBottom:'10px', width:'100%'}} id={el.City} key={el.City}>
            <MenuItem id={el.City}>
            <HiOutlineLocationMarker />{el.City}
            </MenuItem>
            <br />
            <MenuItem id={el.City}>{el.station}</MenuItem>
            </MenuItem>
        })
        }
      </Menu>
    </div>
  );
}